import type { LayoutNode } from './types';

const FIELD_TYPES = new Set<string>([
  'card',
  'stack',
  'grid',
  'indent',
  'divider',
  'static',
  'sum',
  'display',
  'section-label',
  'table',
  'conditional',
  'disabled-when',
  'repeat',
  'OASISRadio',
  'OASISText',
  'OASISDate',
  'OASISNumber',
  'OASISMultiselect',
  'OASISMultiselectOption',
  'radio-option',
]);

/** Try `JSON.parse` + shallow validation that each root item has known `type`. */
export function tryParseLayoutJson(
  raw: string
): { ok: false; error: string } | { ok: true; layout: LayoutNode[] } {
  const text = raw.trim();
  if (!text) return { ok: false, error: 'Layout is empty.' };
  let parsed: unknown;
  try {
    parsed = JSON.parse(text);
  } catch {
    return { ok: false, error: 'Invalid JSON syntax.' };
  }
  if (!Array.isArray(parsed)) {
    return { ok: false, error: 'Layout JSON must be a top-level array.' };
  }
  for (let i = 0; i < parsed.length; i++) {
    const n = parsed[i];
    if (
      n === null ||
      typeof n !== 'object' ||
      typeof (n as { type?: unknown }).type !== 'string'
    ) {
      return {
        ok: false,
        error: `Node at index ${i} is missing string "type".`,
      };
    }
    const t = (n as { type: string }).type;
    if (!FIELD_TYPES.has(t)) {
      return {
        ok: false,
        error: `Unknown node type "${t}" at index ${i}.`,
      };
    }
  }
  return { ok: true, layout: parsed as LayoutNode[] };
}
